import { Component, inject, input, output } from '@angular/core';
import { AggregatedSlot } from '../../models/public-calendar.models';
import { PublicI18nService } from '../../services/public-i18n.service';

@Component({
  selector: 'pc-slot-button',
  standalone: true,
  template: `
    <button
      type="button"
      class="slot-btn w-full"
      [class.selected]="selected()"
      (click)="slotClick.emit(slot())"
    >
      <span class="font-medium">{{ i18n.formatTime(slot().startTime) }}</span>
      <span class="text-xs text-muted ml-1">- {{ i18n.formatTime(slot().endTime) }}</span>
    </button>
  `,
})
export class SlotButtonComponent {
  protected readonly i18n = inject(PublicI18nService);

  slot = input.required<AggregatedSlot>();
  selected = input<boolean>(false);
  slotClick = output<AggregatedSlot>();
}
